import { DownloadButton } from '@features/campaigns/components/DownloadButton';
import { DownloadModal } from '@features/reports/subdomains/cpg';
import { useCurrentReport } from '../hooks/useReports';
import { useCampaignParameters } from '@components/Dashboard/hooks/useCampaign';
import { useCurrentChannel } from '../../../hooks/useCurrentChannel';

type DownloadProps = {
  campaignId: number;
  campaignName: string;
};

export const Download = (props: DownloadProps) => {
  const { report } = useCurrentReport();
  const campaignParams = useCampaignParameters(report?.campaignId);
  const { channel } = useCurrentChannel();

  if (!report) return null;

  return (
    <DownloadModal
      campaignId={props.campaignId}
      campaignName={props.campaignName}
      reportId={report.id}
      renderOpener={onClick => <DownloadButton onClick={onClick} />}
      campaignParams={{ ...campaignParams, id: props.campaignId }}
      channel={channel}
    />
  );
};
